import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import styles from '../../userInformation.module.css';

const FullSsnFallback = () => {
    return (
        <Box className={styles.fallback_container}>
            <Box>
                <Typography className={styles.fallback_heading}>Important:</Typography>
                <Typography className={clsx(styles.fallback_sub_text, styles.dark)}>
                    If verification still fails after providing a full SSN, the user will not be
                    asked to enter it again.
                </Typography>
            </Box>
        </Box>
    );
};

export default FullSsnFallback;
